import { renderToString } from 'preact-render-to-string';

export {
	renderToString,
	renderToString as renderToStaticMarkup
} from 'preact-render-to-string';

export default {
	renderToString,
	renderToStaticMarkup: renderToString
};
